import React from 'react'
import [note_path, notes_path], from: 'config/routes.rb'

# Show component for a single note
export default def Show(note:)
  handleBack = -> { window.location.href = notes_path() }

  %x{
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">{note.title}</h1>
      <div className="prose mb-6">
        <p>{note.body}</p>
      </div>
      <p className="text-sm text-gray-500 mb-4">
        Last updated: {new Date(note.updated_at).toLocaleDateString()}
      </p>
      <button
        onClick={handleBack}
        className="text-blue-600 hover:underline"
      >
        Back to Notes
      </button>
    </div>
  }
end
